import { render, staticRenderFns } from "./SubContents.vue?vue&type=template&id=63cec7c6&scoped=true&"
import script from "./SubContents.vue?vue&type=script&lang=js&"
export * from "./SubContents.vue?vue&type=script&lang=js&"
import style0 from "./SubContents.vue?vue&type=style&index=0&id=63cec7c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cec7c6",
  null
  
)

/* custom blocks */
import block0 from "./SubContents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports